import React from 'react'

function FeedbackFailurePage() {
  return (
    <div>FeedbackFailurePage</div>
  )
}

export default FeedbackFailurePage